import { useEffect, useState } from "react";
import { Plus, Trash2 } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const inp = "w-full px-3 py-2 rounded-lg bg-bg border border-line text-sm focus:outline-none focus:border-[var(--q)]";
const csv = (a) => (a || []).join(", ");
const uncsv = (s) => s.split(",").map((x) => x.trim()).filter(Boolean);

export const CsvInput = ({ value, onChange, testid }) => {
  const [raw, setRaw] = useState(csv(value));
  useEffect(() => { setRaw(csv(value)); }, [value]);
  return <input value={raw} onChange={(e) => setRaw(e.target.value)} onBlur={() => onChange(uncsv(raw))} className={inp} data-testid={testid} />;
};

export const Field = ({ label, children }) => (
  <label className="block space-y-1.5"><span className="eyebrow">{label}</span>{children}</label>
);

export const SectionEditor = ({ s, i, onChange, onRemove, isNew, fixed }) => {
  const set = (k, v) => onChange({ ...s, [k]: v });
  const placeholder = s.title.includes("(belum ditetapkan)");
  return (
    <div className={`rounded-xl border p-4 space-y-3 ${placeholder ? "border-dashed border-[var(--warn)]" : "border-line"}`} data-testid={`fw-section-${s.id || i}`}>
      <div className="flex flex-wrap items-center gap-3">
        <span className="font-mono-data text-xs text-mute">#{s.order}</span>
        <input value={s.id} disabled={!isNew} onChange={(e) => set("id", e.target.value.replace(/[^a-z0-9_]/gi, "").toLowerCase())}
          className={`${inp} !w-32 font-mono-data`} placeholder="id" data-testid={`fw-section-id-${i}`} />
        <div className="flex items-center gap-2 text-sm text-mute ml-auto">
          Aktif <Switch checked={!!s.active && !placeholder} disabled={placeholder || fixed} onCheckedChange={(v) => set("active", v)} data-testid={`fw-section-active-${i}`} />
        </div>
        {isNew && <button onClick={onRemove} aria-label="Buang bahagian" className="text-mute hover:text-warn"><Trash2 size={15} /></button>}
      </div>
      {placeholder && <p className="text-xs text-warn">Belum ditetapkan. Tukar tajuk (buang "(belum ditetapkan)") dan isi tujuan untuk mengaktifkan.</p>}
      <Field label="Nama"><input value={s.title} onChange={(e) => set("title", e.target.value)} className={inp} data-testid={`fw-section-title-${i}`} /></Field>
      <Field label="Tujuan"><textarea rows={2} value={s.purpose} onChange={(e) => set("purpose", e.target.value)} className={inp} data-testid={`fw-section-purpose-${i}`} /></Field>
      <Field label="Arahan AI"><textarea rows={2} value={s.instructions || ""} onChange={(e) => set("instructions", e.target.value)} className={inp} data-testid={`fw-section-instructions-${i}`} /></Field>
      <div className="grid sm:grid-cols-[1fr_1fr_120px_90px] gap-3">
        <Field label="Medan output (koma)"><CsvInput value={s.output_fields} onChange={(v) => set("output_fields", v)} testid={`fw-section-outputs-${i}`} /></Field>
        <Field label="Bergantung pada (koma)"><CsvInput value={s.depends_on} onChange={(v) => set("depends_on", v)} testid={`fw-section-depends-${i}`} /></Field>
        <Field label="Model">
          <Select value={s.model} onValueChange={(v) => set("model", v)}>
            <SelectTrigger className="h-[38px] rounded-lg bg-bg" data-testid={`fw-section-model-${i}`}><SelectValue /></SelectTrigger>
            <SelectContent><SelectItem value="fast">Fast</SelectItem><SelectItem value="main">Main</SelectItem></SelectContent>
          </Select>
        </Field>
        <Field label="Urutan"><input type="number" value={s.order} onChange={(e) => set("order", Number(e.target.value))} className={inp} /></Field>
      </div>
    </div>
  );
};

export const ComponentsEditor = ({ items, onChange }) => (
  <div className="space-y-3" data-testid="fw-components">
    {items.map((c, i) => (
      <div key={i} className={`rounded-xl border p-3 grid sm:grid-cols-[1fr_2fr_auto] gap-3 ${c.nama.includes("(belum ditetapkan)") ? "border-dashed border-[var(--warn)]" : "border-line"}`}>
        <input value={c.nama} onChange={(e) => onChange(items.map((x, j) => j === i ? { ...x, nama: e.target.value } : x))} className={inp} data-testid={`fw-component-nama-${i}`} />
        <textarea rows={1} value={c.huraian} onChange={(e) => onChange(items.map((x, j) => j === i ? { ...x, huraian: e.target.value } : x))} className={inp} placeholder="Huraian / cara guna" data-testid={`fw-component-huraian-${i}`} />
        <button onClick={() => onChange(items.filter((_, j) => j !== i))} aria-label="Buang" className="text-mute hover:text-warn px-2"><Trash2 size={15} /></button>
      </div>
    ))}
    <button onClick={() => onChange([...items, { id: `c${Date.now()}`, nama: "", huraian: "", placeholder: false }])} data-testid="fw-component-add"
      className="h-9 px-4 rounded-full border border-line text-sm inline-flex items-center gap-1.5"><Plus size={14} /> Tambah komponen</button>
  </div>
);

export { inp, csv, uncsv };
